<template>
    <div class="container-fluid">
        <div class="row social">
            <div class="social-title">
                <h1>Social</h1>
            </div>
            <carousel :perPageCustom="[[320, 1], [768, 1], [1000, 3]]" :scrollPerPage="true">
                <slide class="col-md-4 social-item" v-for="(noticia, key) in noticias" :key="key">
                    <div class="social-item-thumb">
                        <img :src="noticia.image" />
                    </div>
                    <div class="social-item-content">
                        <p>{{ noticia.dataFormatada }}</p>
                        <h3>{{ noticia.titulo }}</h3>
                        <p>{{ noticia.descricao }}</p>
                        <small>Lea mas+</small>
                    </div>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    components: {
        Carousel,
        Slide
    },

    data(){
        return {
            noticias : [
                {
                    titulo: 'Resultado concurso cultural "torcida premiada"',
                    descricao: 'Es un placer estar juntos en los momentos más importantes de su vida, sea en su almuerzo, en su cena o en todas sus celebraciones.',
                    dataFormatada: '07/07/2018',
                    image: require('../assets/social/s1.jpg'),
                },
                {
                    titulo: 'Funada completa 66 años',
                    descricao: 'Esta es la Refrigerante Funada, presente a más de 6 décadas en la vida y en la mesa de varias familias en São Paulo, Paraná, Mato Grosso do Sul, Paraguay, Bolivia y Japón.',
                    dataFormatada: '08/07/2018',
                    image: require('../assets/social/s2.jpg'),
                },
                {
                    titulo: 'Novedades en la línea 8 segundos',
                    descricao: 'El sabor que la galera aprobó sigue siendo el mismo, pero ahora en versión 1 litro y con muchas más ventajas.',
                    dataFormatada: '10/07/2018',
                    image: require('../assets/social/s3.jpg'),
                },
                {
                    titulo: 'Resultado concurso cultural "torcida premiada"',
                    descricao: 'Es un placer estar juntos en los momentos más importantes de su vida, sea en su almuerzo, en su cena o en todas sus celebraciones.',
                    dataFormatada: '07/07/2018',
                    image: require('../assets/social/s1.jpg'),
                },
                {
                    titulo: 'Funada completa 66 años',
                    descricao: 'Esta es la Refrigerante Funada, presente a más de 6 décadas en la vida y en la mesa de varias familias en São Paulo, Paraná, Mato Grosso do Sul, Paraguay, Bolivia y Japón.',
                    dataFormatada: '08/07/2018',
                    image: require('../assets/social/s2.jpg'),
                },
                {
                    titulo: 'Novedades en la línea 8 segundos',
                    descricao: 'El sabor que la galera aprobó sigue siendo el mismo, pero ahora en versión 1 litro y con muchas más ventajas.',
                    dataFormatada: '10/07/2018',
                    image: require('../assets/social/s3.jpg'),
                },
            ]
        }
    }
}
</script>

<style scoped>
.container-fluid {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 50px;
}

.social {
    font-family: 'Bambino';
    text-transform: uppercase;
    margin-bottom: 50px;
    display: block;
    width: 100%;
}

.social-title h1 {
    padding-left: 20px;
    font-size: 10pt;
}

.social-item {
    padding: 20px;
}

.social-item h3 {
    font-size: 10pt;
    font-weight: bold;
}

.social-item p {
    font-size: 9pt;
    font-weight: 400;
    text-transform: lowercase;
}

.social-item small {
    position: absolute;
    bottom: 0;
}

.social-item-thumb img {
    width: 100%;
}

.social-item-content {
    margin-top: 15px;    
}

@media only screen and (min-width: 320px) and (max-width: 1024px){
    .row {
        margin-left: 0px;
    }

    .container-fluid {
        padding-top: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Social.vue